import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { ExternalEventSidePanelDetails } from "./ExternalEventSidePanelDetails";

export interface ExternalEventSidePanelProps {
  externalEventId: number
  trigger: JSX.Element
}

export const ExternalEventSidePanel = (props: ExternalEventSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => window.CoreApi.ExternalCalendar.ExternalEvent(props.externalEventId)}
    apiKey="externalEvent"
    entityId={props.externalEventId}
    title={RESX.ExternalCalendar.ExternalEvent}
    footerContent={<>
      <ButtonPrimary href={routes.externalEvent_Detail(props.externalEventId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    trigger={props.trigger}
  >
    {(externalEvent) => <ExternalEventSidePanelDetails
      externalEvent={externalEvent}
    />}
  </DetailSidePanel>
}